import * as ViewUtils from "../src/ViewUtils.scss";
import { Record, Union } from "./fable_modules/fable-library.3.7.20/Types.js";
import { int32_type, lambda_type, unit_type, record_type, string_type, class_type, union_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { CSSProp, HTMLAttr } from "./fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.3.7.20/MapUtil.js";
import { delayAsync, loge, classNames } from "./Utils.js";
import { uncurry, comparePrimitives, max, equals } from "./fable_modules/fable-library.3.7.20/Util.js";
import { singleton, ofArray } from "./fable_modules/fable-library.3.7.20/List.js";
import { ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "./HttpV2.js";
import { FunctionComponent_Of_Z5A158BBF } from "./fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { effect } from "./Components/Hooks/ClickOutside.js";
import { printf, toText, substring } from "./fable_modules/fable-library.3.7.20/String.js";
import { startImmediate } from "./fable_modules/fable-library.3.7.20/Async.js";


export class Size extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Mini", "Small", "Medium", "Large"];
    }
}

export function Size$reflection() {
    return union_type("ViewUtils.Size", [], Size, () => [[], [], [], []]);
}

export const dotsLoading = (() => {
    const children_2 = [react.createElement("div", {
        className: "dot-flashing",
        role: "status",
    })];
    return react.createElement("div", {
        className: "d-flex justify-content-center",
    }, ...children_2);
})();

export const textDotsLoading = react.createElement("div", {
    className: "text-dot-flashing",
    role: "status",
});

export function getMaterialIconBySize(name, size) {
    const props = [new HTMLAttr(65, "material-icons " + ((size.tag === 1) ? "material-icons__small" : ((size.tag === 2) ? "material-icons__normal" : ((size.tag === 3) ? "material-icons__large" : "material-icons__mini"))))];
    return react.createElement("i", keyValueList(props, 1), name);
}

export function getMaterialIcon(name) {
    return getMaterialIconBySize(name, new Size(2));
}

export function getWrappedMaterialIcon(name) {
    const children = [getMaterialIcon(name)];
    return react.createElement("span", {
        className: "d-flex",
    }, ...children);
}

export class Color extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Green", "Yellow", "Grey", "Red"];
    }
}

export function Color$reflection() {
    return union_type("ViewUtils.Color", [], Color, () => [[], [], [], []]);
}

export function getStatusBall(color, title) {
    const classes = classNames(ofArray([["status-ball", true], ["status-ball--green", equals(color, new Color(0))], ["status-ball--yellow", equals(color, new Color(1))], ["status-ball--grey", equals(color, new Color(2))], ["status-ball--red", equals(color, new Color(3))]]));
    return react.createElement("span", {
        className: classes,
        title: title,
    });
}

function createIconUrl(filename) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(3, "/img/svea/icons/" + filename));
    if (matchValue.tag === 1) {
        loge(matchValue.fields[0]);
        return "";
    }
    else {
        return ValidatedUrl__get_Value(matchValue.fields[0]);
    }
}

export class SveaIcon extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Information", "Error", "Warning", "Success", "Attach", "Edit", "Close", "Delete", "SimCard", "PhoneSpec", "Invoice", "Crash", "Checkmark", "ChevronDown", "ChevronRight", "BankID"];
    }
}

export function SveaIcon$reflection() {
    return union_type("ViewUtils.SveaIcon", [], SveaIcon, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function renderSveaIconBySize(icon, size) {
    const props = [new HTMLAttr(149, createIconUrl((icon.tag === 1) ? "error.svg" : ((icon.tag === 2) ? "warning.svg" : ((icon.tag === 3) ? "success.svg" : ((icon.tag === 4) ? "attach.svg" : ((icon.tag === 5) ? "edit.svg" : ((icon.tag === 6) ? "close.svg" : ((icon.tag === 7) ? "delete.svg" : ((icon.tag === 8) ? "sim_card.svg" : ((icon.tag === 9) ? "phone-spec-icon.svg" : ((icon.tag === 10) ? "invoice.svg" : ((icon.tag === 11) ? "crash.svg" : ((icon.tag === 12) ? "checkmark.svg" : ((icon.tag === 13) ? "chevron-down.svg" : ((icon.tag === 14) ? "chevron-right.svg" : ((icon.tag === 15) ? "BankID_logo.svg" : "information.svg")))))))))))))))), new HTMLAttr(65, "svea-icons " + ((size.tag === 1) ? "svea-icons__small" : ((size.tag === 2) ? "svea-icons__normal" : ((size.tag === 3) ? "svea-icons__large" : "svea-icons__mini"))))];
    return react.createElement("img", keyValueList(props, 1));
}

export function renderSveaIcon(icon) {
    return renderSveaIconBySize(icon, new Size(2));
}

export class IconProps extends Record {
    constructor(PopupContent, MaterialIcon) {
        super();
        this.PopupContent = PopupContent;
        this.MaterialIcon = MaterialIcon;
    }
}

export function IconProps$reflection() {
    return record_type("ViewUtils.IconProps", [], IconProps, () => [["PopupContent", class_type("Fable.React.ReactElement")], ["MaterialIcon", string_type]]);
}

const renderIcon$0027 = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2;
    const isOpenState = react.useState(false);
    const containerRef = react.useRef(void 0);
    const popupRef = react.useRef(void 0);
    const iconRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        isOpenState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    let patternInput;
    const matchValue = [popupRef.current, iconRef.current];
    let pattern_matching_result, iconElement, popupElement;
    if (matchValue[0] != null) {
        if (matchValue[1] != null) {
            pattern_matching_result = 0;
            iconElement = matchValue[1];
            popupElement = matchValue[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            patternInput = [popupElement.clientHeight > ((max(comparePrimitives, popupElement.getBoundingClientRect().top + window.scrollY, iconElement.getBoundingClientRect().top + window.scrollY) - 62) - 20), max(comparePrimitives, max(comparePrimitives, popupElement.getBoundingClientRect().right + window.scrollX, iconElement.getBoundingClientRect().right + window.scrollX), popupElement.getBoundingClientRect().left + popupElement.getBoundingClientRect().width) > window.innerWidth];
            break;
        }
        case 1: {
            patternInput = [false, false];
            break;
        }
    }
    const popupClasses = classNames(ofArray([["info-icon__popup", true], ["info-icon__popup--open", isOpenState[0]], ["info-icon__popup--below", patternInput[0]], ["info-icon__popup--behind", patternInput[1]]]));
    const children_4 = [react.createElement("span", {
        className: popupClasses,
        ref: popupRef,
    }, props.PopupContent), (children_2 = [getMaterialIcon(props.MaterialIcon)], react.createElement("span", {
        className: "info-icon__color d-flex pointer",
        ref: iconRef,
        onClick: (e) => {
            e.stopPropagation();
            isOpenState[1]((value) => (!value));
        },
    }, ...children_2))];
    return react.createElement("span", {
        className: "info-icon",
        ref: containerRef,
    }, ...children_4);
}, void 0, uncurry(2, void 0), void 0, "renderIcon\u0027", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\ViewUtils.fs", 175);

export class MaterialIcon {
    constructor() {
    }
}

export function MaterialIcon$reflection() {
    return class_type("ViewUtils.MaterialIcon", void 0, MaterialIcon);
}

export function MaterialIcon_render_12EF8ABE(materialIcon, onClick) {
    let children;
    const children_2 = [(children = [getMaterialIcon(materialIcon)], react.createElement("span", {
        className: "info-icon__color d-flex pointer",
        onClick: (e) => {
            e.stopPropagation();
            onClick(e);
        },
    }, ...children))];
    return react.createElement("span", {
        className: "info-icon",
    }, ...children_2);
}

export function MaterialIcon_render_Z132847CC(props) {
    return renderIcon$0027(props);
}

export function MaterialIcon_render_Z384F8060(materialIcon, popupText) {
    return MaterialIcon_render_Z132847CC(new IconProps(react.createElement(react.Fragment, {}, popupText), materialIcon));
}

export function MaterialIcon_render_6162D7CC(materialIcon, element) {
    return MaterialIcon_render_Z132847CC(new IconProps(element, materialIcon));
}

export class MaterialIconBall {
    constructor() {
    }
}

export function MaterialIconBall$reflection() {
    return class_type("ViewUtils.MaterialIconBall", void 0, MaterialIconBall);
}

export function MaterialIconBall_render_Z4D0A3336(materialIcon, size, onClick) {
    const classes = classNames(ofArray([["material-ball-icon", true], ["material-ball-icon--mini", equals(size, new Size(0))], ["material-ball-icon--small", equals(size, new Size(1))], ["material-ball-icon--medium", equals(size, new Size(2))], ["material-ball-icon--large", equals(size, new Size(3))]]));
    const children = [getMaterialIconBySize(materialIcon, size)];
    return react.createElement("span", {
        className: classes,
        onClick: (e) => {
            e.stopPropagation();
            onClick(e);
        },
    }, ...children);
}

export function bouncingBox(contentHtml) {
    return react.createElement("div", {
        className: "bouncing-box",
    }, contentHtml);
}

export function getFileEndingIcon(filename) {
    let extensionStr;
    const i = filename.lastIndexOf(".") | 0;
    extensionStr = ((i === -1) ? "" : substring(filename, i).toLocaleLowerCase());
    switch (extensionStr) {
        case ".pdf": {
            return "picture_as_pdf";
        }
        case ".txt": {
            return "description";
        }
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".jfif":
        case ".gif":
        case ".tiff":
        case ".tif": {
            return "image";
        }
        case ".wav":
        case ".mp3":
        case ".amr":
        case ".ogg":
        case ".m4a":
        case ".wma": {
            return "audio_file";
        }
        default: {
            return "unknown_document";
        }
    }
}

export class LoadingBarProps extends Record {
    constructor(LoadFn, TimeBetweenLoadMs) {
        super();
        this.LoadFn = LoadFn;
        this.TimeBetweenLoadMs = (TimeBetweenLoadMs | 0);
    }
}

export function LoadingBarProps$reflection() {
    return record_type("ViewUtils.LoadingBarProps", [], LoadingBarProps, () => [["LoadFn", lambda_type(unit_type, unit_type)], ["TimeBetweenLoadMs", int32_type]]);
}

export const renderLoadingBar = FunctionComponent_Of_Z5A158BBF((props) => {
    let css, props_1;
    const noAnimationClass = "loading-bar__progress-value";
    const doAnimationClass = "loading-bar__progress-value loading-bar__progress-value--filled";
    const animateClassesState = react.useState(noAnimationClass);
    react.useEffect(() => {
        const disp = (() => {
        const stopAnimation = () => {
            animateClassesState[1](noAnimationClass);
        };
        const startAnimation = () => {
            animateClassesState[1](doAnimationClass);
        };
        stopAnimation();
        startImmediate(delayAsync(100, () => {
            startAnimation();
        }));
        const intervalId = window.setInterval(() => {
            stopAnimation();
            props.LoadFn();
            startImmediate(delayAsync(100, () => {
                startAnimation();
            }));
        }, props.TimeBetweenLoadMs);
        return {
            Dispose() {
                window.clearInterval(intervalId);
            },
        };
    })();
        return () => disp.Dispose();
    }, [props.LoadFn, props.TimeBetweenLoadMs]);
    const isFilled = (animateClassesState[0]) === doAnimationClass;
    const transitionMs = max(comparePrimitives, 0, props.TimeBetweenLoadMs - 300) | 0;
    const transitionStyle = isFilled ? ((css = singleton(new CSSProp(372, toText(printf("%dms width linear"))(transitionMs))), ["style", keyValueList(css, 1)])) : ["style", {
        transition: "none",
    }];
    const children_2 = [(props_1 = [new HTMLAttr(65, animateClassesState[0]), transitionStyle], react.createElement("div", keyValueList(props_1, 1)))];
    return react.createElement("div", {
        className: "loading-bar",
    }, ...children_2);
}, "LoadingBar", uncurry(2, void 0), void 0, "renderLoadingBar", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\ViewUtils.fs", 300);

export function renderAnimationCheckmark(saveStatus) {
    switch (saveStatus.tag) {
        case 1: {
            const children_6 = [react.createElement("div", {
                className: "circle-loader-checkmark draw",
            })];
            return react.createElement("div", {
                className: "circle-loader",
            }, ...children_6);
        }
        case 3: {
            return react.createElement("div", {
                className: "circle-loader circle-loader--fail",
            });
        }
        case 2: {
            const children_12 = [react.createElement("div", {
                className: "circle-loader-checkmark draw",
            })];
            return react.createElement("div", {
                className: "circle-loader circle-loader--complete",
            }, ...children_12);
        }
        default: {
            const children_2 = [react.createElement("div", {
                className: "circle-loader-checkmark draw",
            })];
            return react.createElement("div", {
                className: "circle-loader circle-loader--empty",
            }, ...children_2);
        }
    }
}

